import { TableCell } from "@mui/material"
import { useEffect, useState } from "react"
import { validateQuantity } from "../../../../utils/validations";
import { formatCost } from "../../../../utils/format";
import { useSelector } from "react-redux";

interface PlanRevisedQtyTableCellProps {
    recipemog: any;
    handleSaveMogQty: any;
}


const PlanRevisedQtyTableCell: React.FC<PlanRevisedQtyTableCellProps> = ({ recipemog, handleSaveMogQty }: any) => {
    const { params: ProductionPlanParams } = useSelector((state: any) => state.productionPlan);
    const isDisabled = ProductionPlanParams?.disableKI ?? false;
    const [quantity, setQuantity] = useState<string>("");
    const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (validateQuantity(value, 'Kg')) {
            setQuantity(value);
        }
    }

    const handleQuantityBlur = () => {
        const currentSavedQty = recipemog?.revisedquantity == null ? recipemog?.planquantity : recipemog?.revisedquantity;
        if (String(currentSavedQty) !== String(quantity) && String(quantity) !== "") {
            handleSaveMogQty(quantity, recipemog?.mogcode, recipemog?.articlenumber);
        }
    }

    useEffect(() => {
        setQuantity(recipemog?.revisedquantity == null ? String(recipemog?.planquantity) : String(recipemog?.revisedquantity));
    }, [recipemog]);

    return (
        <>
            <TableCell className='grey-bg'>
                {!recipemog?.isdeletable ? formatCost(recipemog?.planquantity, 3) : "-"}
            </TableCell>
            <TableCell >
                <input type="text" value={quantity} onChange={(e) => handleQuantityChange(e)} onBlur={handleQuantityBlur} placeholder="0.00" disabled={isDisabled} />
            </TableCell>
        </>
    )
}

export default PlanRevisedQtyTableCell